import { gql } from "@apollo/client";

export const getHostedLensList = gql`
    query getHostedLensList($organizationId: ID!) {
        getHostedLenses(input: { organizationId: $organizationId }) {
            lensesList {
                id
                link
                reference
                status
                organizationId
                hostedLensMetadata {
                    name
                    iconUrl
                    lensId
                }
            }
        }
    }
`;
